import { Loader } from "@mantine/core";
import { ComponentProps } from "react";
import { FieldValues } from "react-hook-form";

import { useGetCompaniesQuery } from "@/store";
import { transformInOptions } from "@/utils";

import { Input } from "../_Input";

type CompaniesFieldsProps<TFieldValues extends FieldValues> = Omit<ComponentProps<typeof Input.Select<TFieldValues>>, "data" | "leftSection">;

export function CompaniesFields<TFieldValues extends FieldValues>({ control, name, ...props }: CompaniesFieldsProps<TFieldValues>) {
  const { data, isLoading } = useGetCompaniesQuery(undefined, {
    selectFromResult: (state) => ({
      ...state,
      data: {
        options: transformInOptions(state.data),
        response: state.data
      }
    })
  });

  return (
    <Input.Select data={data.options} leftSection={isLoading && <Loader size="sm" />} placeholder="Selecione a Empresa" label="Empresa" control={control} name={name} {...props} />
  );
}
